import { DynamicBaseForm } from './dynamic-base-form';

export class TextBoxNumberForm extends DynamicBaseForm<string> {
    controlType = 'TextBoxNumberForm';
}